var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainStation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.313 8.5l-6.738-3h4.917l6.738 3 .053-.024.011.024H22v2h-4.345l-6.738 3H22v2h-9.738l6.738 3h-4.917l-6.738-3H2v-2h4l6.738-3H2v-2h10.313z",
    fill: "#EF2721"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.313 8.5l-6.738-3h4.917l6.738 3 .053-.024.011.024H22v2h-4.345l-6.738 3H22v2h-9.738l6.738 3h-4.917l-6.738-3H2v-2h4l6.738-3H2v-2h10.313z",
    fill: "#EF2721"
  })));
}
export default SvgTrainStation;